import { Navigate } from 'react-router-dom';
import  Properties  from '../Properties';
import AllProperties  from '../Properties/all'
import NewAppartment  from '../Properties/new'
import Dashboard  from '../Dashboard'
import Units  from '../Units'
import NewUnit  from '../Units/new'
import Tenants  from '../Tenants'
import NewTenant  from '../Tenants/new'
import Utilities  from '../Utilities'
import NewUtitlity  from '../Utilities/new'
import Maintenances  from '../Maintenances'
import NewMaintenance  from '../Maintenances/new'
import UnitLabels  from '../UnitLabels'
import NewUnitLabel  from '../UnitLabels/new'
import Invoices  from '../Invoices'
import NewInvoice  from '../Invoices/new'
import Payments  from '../Payments'
import NewPayment  from '../Payments/new'
import Tenant  from '../Tenants/Tenant'
import NewEmail  from '../Tenants/Email/new'
import Arrears  from '../Arrears'
import NewArrear  from '../Arrears/new'
import Deductions  from '../Deductions'
import Expenditures  from '../Expenditures';
import Plans from '../Plans';
import PayForPlan from '../Plans/payForPlan';
import UnitsGallery from '../Units/gallery';
import NewBank from '../Bank/new';
import Banks from '../Bank/index ';
import BankDashboard from '../BankDashboard';
import AdminUsers from '../AdminUsers';
import Invoice from '../Invoices/invoice';
import General from '../General';
import AdminWithdrawals from '../AdminWithdrawals';
import AdminPayments from '../AdminPayments';
import AdminLandlords from '../AdminLandlords';
import AdminReferrals from '../AdminReferrals';
import AdminLockTabs from '../AdminLockTabs';
import AdminBnBTabs from '../AdminBnBTabs';
import TenantsUploadData from '../Tenants/UploadData';
import ReminderDates from '../ReminderDates';
import Contacts from '../Contacts';
import NewContact from '../Contacts/new';
import Reviews from '../Reviews';
import Collaborators from '../Collaborators';
import AddCollaborator from '../Collaborators/add';
import PaymentAccount from '../PaymentAccount';
import VacationNotices from '../VacationNotices';
import ProcessVacationNotice from '../VacationNotices/process';


const Screens = [
    { path: '/', element: <Properties /> },
    { path: '/plans', element: <Plans /> },
    { path: '/pay_for_plan', element: <PayForPlan /> },
    { path: '/properties', element: <Properties /> },
    { path: '/all_properties', element: <AllProperties /> },
    { path: '/new_property', element: <NewAppartment /> },
    { path: '/dashboard', element: <Dashboard /> },
    { path: '/units', element: <Units /> },
    { path: '/new_unit', element: <NewUnit /> },
    { path: '/tenants', element: <Tenants /> },
    { path: '/new_tenant', element: <NewTenant /> },
    { path: '/utilities', element: <Utilities /> },
    { path: '/new_utility', element: <NewUtitlity /> },
    { path: '/maintenances', element: <Maintenances /> },
    { path: '/new_maintenance', element: <NewMaintenance /> },
    { path: '/units_labels', element: <UnitLabels /> },
    { path: '/new_unitLabel', element: <NewUnitLabel /> },
    { path: '/invoices', element: <Invoices /> },
    { path: '/new_invoice', element: <NewInvoice /> },
    { path: '/payments', element: <Payments /> },
    { path: '/new_payment', element: <NewPayment /> },
    { path: '/tenant', element: <Tenant /> },
    { path: '/new_email', element: <NewEmail /> },
    { path: '/arrears', element: <Arrears /> },
    { path: '/new_arrear', element: <NewArrear /> },
    { path: '/deductions', element: <Deductions /> },
    { path:  '/expenditures', element: <Expenditures/>},
    { path:  '/UnitsGallery', element: <UnitsGallery/>},
    { path:  '/new_bank', element: <NewBank/>},
    { path:  '/banks', element: <Banks/>},
    { path:  '/bank_dashboard', element: <BankDashboard/>},
    { path:  '/admin_users', element: <AdminUsers/>},
    { path:  '/admin_general', element: <General/>},
    { path:  '/admin_withdrawals', element: <AdminWithdrawals/>},
    { path:  '/admin_payments', element: <AdminPayments/>},
    { path:  '/admin_landlords', element: <AdminLandlords/>},
    { path:  '/admin_referrals', element: <AdminReferrals/>},
    // all the lock pages are tabs of one page; the old addresses still work
    { path:  '/admin_locks', element: <AdminLockTabs/>},
    { path:  '/admin_smart_locks', element: <Navigate to="/admin_locks?tab=smart-locks" replace />},
    { path:  '/admin_unlock_records', element: <Navigate to="/admin_locks?tab=unlock-records" replace />},
    { path:  '/admin_lock_orders', element: <Navigate to="/admin_locks?tab=orders" replace />},
    // the BnB pages are tabs of one page too, the same way the lock pages are
    { path:  '/admin_bnb', element: <AdminBnBTabs/>},
    { path:  '/admin_bnb_reported_issues', element: <Navigate to="/admin_bnb?tab=reported-issues" replace />},
    { path:  '/tenants_data', element: <TenantsUploadData/>},
    { path:  '/invoice', element: <Invoice/>},
    { path:  '/reminder_dates', element: <ReminderDates/>},
    { path:  '/contacts', element: <Contacts/>},
    { path:  '/new_contact', element: <NewContact/>},
    { path:  '/reviews', element: <Reviews/>},
    { path:  '/collaborators', element: <Collaborators/>},
    { path:  '/add_collaborator', element: <AddCollaborator/>},
    { path:  '/payment_account', element: <PaymentAccount/>},
    { path:  '/vacation_notices', element: <VacationNotices/>},
    { path:  '/vacation_notices/process', element: <ProcessVacationNotice/>}




]
const routes: any[] = Screens

export default routes;